import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgrxFormsModule } from 'ngrx-forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { UserProfileService } from '../../../../services/user/user.profile.service';
import { ViewModel } from '../../../../services/user/view.model';
import { AdminUserDevicesComponent } from './component/devices.component';
import { DevicesSharedNumberComponent } from './component/shared-numbers/devices-shared-number.component';
import { AvailableDevicesSelectors } from './state/available-devices.selector';
import { UserDevicesActions } from './state/user-devices.actions';
import { AdminUserDevicesEffects } from './state/user-devices.effect';
import { adminUserDevicesStateReducers } from './state/user-devices.reducer';
import { UserDevicesSelectors } from './state/user-devices.selectors';
import { GatewaySelectors } from '../../../../core/state/gateway.selectors';
import { UserSelectors } from '../../../../user/state/user.selectors';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule.forRoot(),

        StoreModule.forFeature('userDevicesForm', adminUserDevicesStateReducers),
        EffectsModule.forFeature([AdminUserDevicesEffects]),

        FormsModule,
        NgrxFormsModule // needs FormsModule
    ],
    declarations: [
        AdminUserDevicesComponent,
        DevicesSharedNumberComponent
    ],
    providers: [
        UserProfileService,
        ViewModel,
        UserDevicesActions,
        UserDevicesSelectors,
        AvailableDevicesSelectors,
        UserSelectors,
        GatewaySelectors
    ]
})
export class UserDevicesModule {
}
